import { User } from '@discord/embedded-app-sdk/output/schema/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SDKQuestData {
    quest_id: string;
    external_cta_url: string;
    enrolled_at?: string | null | undefined;
    completed_at?: string | null | undefined;
}

interface DiscordState {
    questStatus?: 'not_enrolled' | 'enrolled' | 'completed';
    questCTAURL?: string;
    questStatusChecked?: boolean;
    windowSize: 'minimized' | 'maximized';
    locale?: string;
    user?: User;
}

const initialState: DiscordState = {
    questStatus: undefined,
    windowSize: 'maximized',
    locale: undefined,
};

export const initialDiscordState = initialState;

const discord = createSlice({
    name: 'discord',
    initialState,
    reducers: {
        setQuestFromSDK(state, action: PayloadAction<SDKQuestData>) {
            const payload = action.payload;
            state.questCTAURL = payload.external_cta_url;
            state.questStatusChecked = true;

            if (payload.completed_at) {
                state.questStatus = 'completed';
            } else if (payload.enrolled_at) {
                state.questStatus = 'enrolled';
            } else {
                state.questStatus = 'not_enrolled';
            }
        },
        setQuestStatus(state, action) {
            state.questStatus = action.payload;
            state.questStatusChecked = true;
        },
        setWindowSize(state, action) {
            state.windowSize = action.payload;
        },
        setDiscordLocale(state, action) {
            state.locale = action.payload;
        },
        setDiscordUser(state, action) {
            state.user = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

export const { setQuestStatus, setWindowSize, setDiscordLocale, setDiscordUser, setQuestFromSDK } = discord.actions;

export const { actions: discordActions, reducer: discordReducer } = discord;

export default discordReducer;
